export const OnioTabStyles = (theme: any) => {
    return {
        [theme.breakpoints.down('sm')]: {
            width: 150,
            justifyContent: " flex-start",
            paddingTop: "24px"
        }
    }
}